import React from 'react';
import { Box, CircularProgress } from '@material-ui/core/';
import styled from 'styled-components';
// import { useSelector } from 'react-redux';

const ContainedDiv = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  /* background: rgba(0, 0, 0, 0.3); */
  text-align: center;
  border-radius: 20px;
  margin: 1rem;
`;

export default function LimitedBackdropLoading({
  action,
  color = 'primary',
  thickness = 4,
  size = 125,
  ...props
}) {
  return (
    <ContainedDiv>
      <Box p={5}>
        <CircularProgress color={color} size={size} thickness={thickness} />
      </Box>
    </ContainedDiv>
  );
}
